import React from "react";

import { Backdrop, CircularProgress } from "@mui/material";

export function LoadingOverlay(props: { open: boolean }) {
  return (
    <Backdrop open={props.open} sx={{ zIndex: (t) => t.zIndex.modal + 1 }}>
      <CircularProgress />
    </Backdrop>
  );
}
